export const getUserPermissions = (user) => {
  if (!user) return [];
  const permissions = Array.isArray(user.permissions) ? user.permissions : [];
  const unique = new Set(permissions.filter(Boolean));
  return Array.from(unique);
};

export const getUserRoles = (user) => {
  if (!user) return [];
  const roles = Array.isArray(user.roles)
    ? user.roles
    : Array.isArray(user.Roles)
      ? user.Roles
      : [];
  const unique = new Set(
    roles
      .map((role) => (typeof role === 'string' ? role : role?.name))
      .filter(Boolean)
  );
  return Array.from(unique);
};

const normalizedRoleNames = (user) => Array.from(new Set([
  ...getUserRoles(user),
  ...(Array.isArray(user?.platformRoles) ? user.platformRoles : []),
].map((role) => (typeof role === 'string' ? role : role?.name)).filter(Boolean)))
  .map((role) => String(role).replace(/[\s_-]/g, '').toLowerCase());

export const isSuperAdminUser = (user) => normalizedRoleNames(user).includes('superadmin');

export const isBusinessOwnerUser = (user) => normalizedRoleNames(user).includes('businessowner');

export const hasAdminRole = (user) => {
  if (!user) return false;
  return isSuperAdminUser(user) || normalizedRoleNames(user).includes('admin');
};

export const isAdminUser = (user) => {
  if (!user) return false;
  return hasAdminRole(user);
};

export const hasPermission = (user, permissionKey) => {
  if (!user || !permissionKey) return false;
  if (isSuperAdminUser(user)) return true;
  const permissions = getUserPermissions(user);
  if (isBusinessOwnerUser(user)) {
    const personalMutationPermissions = new Set([
      'profile.update',
      'profile.change_password',
      'preferences.update',
      'printing.preferences.update',
      'favorites.update',
      'favorites.manage',
    ]);
    const isReadPermission = permissionKey.endsWith('.read')
      || permissionKey === 'branch.access.any';
    if (!isReadPermission && !personalMutationPermissions.has(permissionKey)) return false;
  }
  return permissions.includes(permissionKey);
};

export const hasAnyPermission = (user, permissionKeys) => {
  if (!Array.isArray(permissionKeys) || !permissionKeys.length) return false;
  return permissionKeys.some((key) => hasPermission(user, key));
};
